import router from './router'
import store from './store'

import { getToken } from '@/utils/auth'
import { Message } from 'element-ui'

router.beforeEach((to, from, next) => {
  //检查token，没有token跳转登录页
  if (getToken()) {
    if(to.path == '/login') {
      next()
    } else {
      if(!store.getters.currentUser) {
        //保存当前用户
        store.dispatch("GetUserInfo").then(res => {
        }).catch(err => {
        });
      }
      if(!store.getters.companyOrgs){
        //判断用户类型（目前无法区分业务员和财务人员）：如果是财务则获取财务组织列表
        store.dispatch("GetCompanyInfo").then(res =>{
        }).catch(err => {});
      }
      //有token，加载菜单
      if(store.getters.menus.length === 0) {
        store.dispatch('GenerateMenus').then(res => {
          if(res) {
            router.addRoutes(res);
            next({ ...to, replace: true }); // hack方法 确保addRoutes已完成
          } else {
            Message.error("当前用户未分配菜单权限");
          }
        }).catch(err => {
        })
      } else {
        next()
      }
    }
  } else {
    if(to.path.includes('/register')){
      next()
    }else if (to.path !== '/login') {
      next({ path: '/login' })
    } else {
      next()
    }
  }

})

router.afterEach(() => {
  // NProgress.done()
})
